// src/pages/HRHolidays.js
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./HRHolidays.css";
import apiClient from "../utils/apiClient";
import SessionHandler from "../components/SessionHandler";

const HRHolidays = () => {
  const [holidays, setHolidays] = useState([]);
  const [upcomingHolidayId, setUpcomingHolidayId] = useState(null);

  // 🔴 Modal states
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);

  const navigate = useNavigate();

  // ✅ Fetch holidays
  const fetchHolidays = useCallback(async () => {
    try {
      const data = await apiClient("/holiday/");
      if (!data) return;

      const list =
        Array.isArray(data)
          ? data
          : Array.isArray(data.results)
          ? data.results
          : [];

      setHolidays(list);
      setUpcomingHolidayId(getUpcomingHolidayId(list));
    } catch (err) {
      console.error("Error fetching holidays:", err.message);
    }
  }, []);

  useEffect(() => {
    fetchHolidays();
  }, [fetchHolidays]);

  const getUpcomingHolidayId = (holidays) => {
    const now = new Date();
    for (let holiday of holidays) {
      if (new Date(holiday.date) >= now) return holiday.id;
    }
    return null;
  };

  // 🟡 Open confirmation modal
  const openDeleteModal = (holiday) => {
    setSelectedHoliday(holiday);
    setShowDeleteModal(true);
  };

  // ❌ Cancel delete
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedHoliday(null);
  };

  // ✅ Confirm delete
  const confirmDelete = async () => {
    if (!selectedHoliday) return;

    try {
      await apiClient(
        `/holiday/${selectedHoliday.id}/`,
        { method: "DELETE" }
      );
      closeDeleteModal();
      fetchHolidays();
    } catch (err) {
      console.error("Error deleting holiday:", err.message);
    }
  };

  const handleAddHoliday = () => {
    navigate("/dashboard/ManagerAcess/hraddholiday");
  };

  return (
    <div className="holiday-container">
      <div className="holiday-header">
        <button className="add-holiday-btn" onClick={handleAddHoliday}>
          +
        </button>
        <h1 className="holiday-title">📅 Holidays</h1>
      </div>

      <div className="holiday-table-wrapper">
        <table className="holiday-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Name of Holiday</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {holidays.length > 0 ? (
              holidays.map((holiday, index) => (
                <tr
                  key={holiday.id}
                  className={
                    holiday.id === upcomingHolidayId
                      ? "highlight-upcoming"
                      : ""
                  }
                >
                  <td>{index + 1}</td>
                  <td>{holiday.name}</td>
                  <td>{holiday.date}</td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => openDeleteModal(holiday)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No holidays found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* 🔴 Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal-overlay45">
          <div className="modal-box45">
            <h3>Confirm Delete</h3>
            <p>
              Are you sure you want to delete
              <strong> {selectedHoliday?.name}</strong>?
            </p>

            <div className="modal-actions">
              <button className="modal-cancel" onClick={closeDeleteModal}>
                Cancel
              </button>
              <button className="modal-delete" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <SessionHandler />
    </div>
  );
};

export default HRHolidays;
